<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" />
  </ng-container>

  <ng-container body>
    <table>
      <!-- When -->
      <tr>
        <td class="event-notification-title-col">
          <email-text [contents]="data.time.title" color="light" />
        </td>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
        <td width="100%">
          <email-text [contents]="data.time.duration_html" />
          <br />
          <email-text [contents]="data.time.timezone" color="light" />
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <email-margin [height]="16" />
        </td>
      </tr>
      <!-- Interviewers -->
      <tr>
        <td class="event-notification-title-col">
          <email-text [contents]="data.interviewers.title" color="light" />
        </td>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
        <td><email-text [contents]="data.interviewers.body" [bold]="true" /></td>
      </tr>
      <tr>
        <td colspan="3">
          <email-margin [height]="16" />
        </td>
      </tr>
      <!-- Candidate -->
      <ng-container *mailgunIf="data.candidate">
        <tr>
          <td class="event-notification-title-col">
            <email-text [contents]="data.candidate?.title!" color="light" />
          </td>
          <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td><email-text [contents]="data.candidate?.body!" [bold]="true" /></td>
        </tr>
        <tr>
          <td colspan="3">
            <email-margin [height]="16" />
          </td>
        </tr>
      </ng-container>

      <!-- Link -->
      <tr>
        <td class="event-notification-title-col">
          <email-text [contents]="data.link.title" color="light" />
        </td>
        <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
        <td>
          <email-link
            [href]="data.link.url"
            [label]="data.link.url"
            [textOpts]="{ bold: true, color: 'primary' }"
          />
        </td>
      </tr>

      <!-- Public note -->
      <ng-container *mailgunIf="data.public_note">
        <tr>
          <td colspan="3">
            <email-margin [height]="16" />
          </td>
        </tr>
        <tr>
          <td class="event-notification-title-col">
            <email-text [contents]="data.public_note?.title!" color="light" />
          </td>
          <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td><email-text [contents]="data.public_note?.body!" /></td>
        </tr>
      </ng-container>

      <!-- Private note -->
      <ng-container *mailgunIf="data.private_note">
        <tr>
          <td colspan="3">
            <email-margin [height]="16" />
          </td>
        </tr>
        <tr>
          <td class="event-notification-title-col">
            <email-text [contents]="data.private_note?.title!" color="light" />
          </td>
          <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
          <td><email-text [contents]="data.private_note?.body!" /></td>
        </tr>
      </ng-container>
    </table>
  </ng-container>

  <ng-container footer>
    <ng-container *mailgunIf="data.footer">
      <email-text [contents]="data?.footer!" color="light" presetName="inline" size="small" />&nbsp;
    </ng-container>
  </ng-container>
</email-layout>
